// Material UI v1.4.0 has issue between <Card> and <Autocomplete> components
// <Autocomplete> gets cut by <Card> container because of `overflow:hidden` set.
//  https://github.com/mui-org/material-ui/pull/10946
//  https://github.com/mui-org/material-ui/pull/11572
//  https://github.com/mui-org/material-ui/issues/2623
// Below mitigate this issue

import { List as CustomList } from 'react-admin';
import styled from 'styled-components';

export const List = styled(CustomList)`
    && {
        width: 100%;
        max-width: 1920px;
        margin-left: auto;
        margin-right: auto;
    }

    && > div {
        background-color: transparent;
        box-shadow: none;
        overflow: initial;
    }
`;
